module.exports = __webpack_public_path__ + "img/image01_sp.f07b7880.jpg";